import { render, staticRenderFns } from "./PassengerflowViewGb.vue?vue&type=template&id=0691eb5a&scoped=true"
import script from "./PassengerflowViewGb.vue?vue&type=script&lang=js"
export * from "./PassengerflowViewGb.vue?vue&type=script&lang=js"
import style0 from "./PassengerflowViewGb.vue?vue&type=style&index=0&id=0691eb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0691eb5a",
  null
  
)

export default component.exports